<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100 md-size-30">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>apps</md-icon>
          </div>
          <h4 class="title">Client Info Page</h4>
        </md-card-header>
        <div class="card-content">
          <md-table class="m-4">
            <row-item-view label="Name" :value="client.name"/>

            <row-item-view label="Redirect" :value="client.redirect"/>

            <row-item-view label="Secret"
                           :value="client.secret"/>
            <row-item-view label="id"
                           :value="client.client_id"/>
            <row-item-view label="revoked"
                           :value="client.revoked"/>
          </md-table>
        </div>
      </md-card>
    </div>

    <div class="md-layout-item">
      <md-card-content>
      </md-card-content>
    </div>
  </div>
</template>

<script>
// import {Modal, NavTabsCard} from "@/components";
// import Multiselect from 'vue-multiselect'

// import ItemsView from "../../../components/Inputs/ItemsView";
// import ItemView from "../../../components/Inputs/ItemView";
// import Swal from "sweetalert2";
// import SkillActivitiesTable from "../../../components/Tables/SkillActivitiesTable";
// import SkillLabourersTable from "../../../components/Tables/SkillLabourersTable";
import RowItemView from '../../../components/Inputs/RowItemView';

export default {
    components: {
        RowItemView
    },

    data: () => ({

        client: {
            type: 'clients',
            name: null,
            redirect: null,
            revoked: null,
            id: null,
            secret: null,
        },
        isLoading: false,
    }),

    created () {
        this.get();
    },

    methods: {
        async get () {
            try {
                console.log(this.$route.params.id);
                const id = this.$route.params.id;
                let params = {
                    id: id
                };
                await this.$store.dispatch('clients/get', params);
                console.log(this.client);
                this.client = this.$store.getters['clients/client'];
                console.log(this.client);
            } catch (e) {
                await this.$store.dispatch('alerts/alert', e.response ? e.response : e.message);
            }
        },

        async update () {
            try {
                await this.$store.dispatch('clients/update', this.client);
                await this.$store.dispatch(
                    'alerts/success',
                    'Client updated successfully.'
                );
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].title
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        goBack () {
            this.$router.push({ name: 'List Client' });
        },
        goToEdit (id) {
            this.$router.push({ name: 'Edit Client', params: { id } });
        },
    },
};
</script>
